import React, { useEffect, useState, lazy, Suspense } from 'react';
import 'react-quill/dist/quill.snow.css'; // Import the CSS for Quill
import { Typography } from '@mui/material';

const ReactQuill = lazy(() => import('react-quill')); // Dynamically import ReactQuill

const RichTextComponent = (props) => {
  const [editorHtml, setEditorHtml] = useState('');

  const handleChange = (html) => {
    setEditorHtml(html);
    props.setTextInput(html);
  };

  useEffect(() => {
    setEditorHtml(props?.textInput || '');
  }, [props.textInput]);

  return (
    <div>
      <Typography style={{ marginBottom: '5px',fontSize:'14px',color:'black' }}>
        {props.title}{" "}
        {props.required && <span style={{ color: "red" }}>*</span>}
      </Typography>
      
      {/* Use Suspense to wrap the lazy-loaded component */}
      <Suspense fallback={<div>Loading editor...</div>}>
        <ReactQuill
          theme="snow" // Set the default theme directly here
          onChange={handleChange}
          value={editorHtml}
          modules={RichTextComponent.modules}
          formats={RichTextComponent.formats}
          bounds={'.app'}
          placeholder={props.placeholder}
        />
      </Suspense>
    </div>
  );
};

RichTextComponent.modules = {
  toolbar: [
    [{ 'header': '1'}, { 'header': '2' }, { 'font': [] }],
    [{ 'size': [] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
    ['link'],
    [{ 'align': [] }],
    ['clean'],
    ['code-block'],
    [{ 'script': 'sub' }, { 'script': 'super' }]
  ],
  clipboard: {
    matchVisual: false,
  }
};

RichTextComponent.formats = [
  'header', 'font', 'size',
  'bold', 'italic', 'underline', 'strike', 'blockquote',
  'list', 'bullet', 'indent',
  'link', 
  'align', 'color', 'background',
  'code-block',
  'script'
];

export default RichTextComponent;
